import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Close from 'react-icons/lib/io/close';
import SvgIcon from '@material-ui/core/SvgIcon';
import Calendar from 'react-icons/lib/fa/calendar-o';
import {FormattedMessage} from 'react-intl';
import DialogWrapper from '../../../components/dialog/Dialog';
import SvgIconButton from '../../../components/SvgIconButton';
import {actions, category, events, PromoType} from '../../../constants/enums';
import Teacher from '../../../assets/images/promo/Stacy-White.jpg';
import Founder from '../../../assets/images/promo/Yoni.jpg';
import Webinar from '../../../assets/images/promo/Webinar.png';
import TeacherM from '../../../assets/images/promo/Stacy-White-M.jpg';
import FounderM from '../../../assets/images/promo/Yoni-M.jpg';
import WebinarM from '../../../assets/images/promo/Webinar-M.png';
import './styles.scss';
import {isMobile} from '../../../utils/screenUtility';
import {setUserProperties} from '../../../utils/userUtility';
import {customEvent} from '../../../utils/analyticsUtil';

const promoList = [
    {
        type: PromoType.Teacher,
        image: isMobile() ? TeacherM : Teacher,
        person: {
            name: 'Stacy White',
            role: 'Piano Teacher'
        },
        title: 'Musico Supports Teacher Training',
        description: '“Musico’s built-in promo helped me get my students up and running fast… It’s easy to set up a call, they can help you get started in under 10 minutes!”',
        link: '/book-a-meeting?utm_source=Website&utm_medium=Promo&utm_campaign=TeacherInvite'
    },
    {
        type: PromoType.Founder,
        image: isMobile() ? FounderM : Founder,
        person: {
            name: 'Yonatan Pistiner',
            role: 'Co-Founder'
        },
        title: 'Book A Session With The Founder!',
        description: '"I started Musico to help teachers and students stay more connected between lessons. Now, I get to connect with teachers all over the world just like you!  Let’s book a call and I’ll personally help you get set up for success."',
        link: '/book-a-meeting?utm_source=Website&utm_medium=Promo&utm_campaign=FounderInvite'
    },
    {
        type: PromoType.Webinar,
        image: isMobile() ? WebinarM : Webinar,
        person: null,
        title: 'Sign Up For Teacher Training',
        description: '“Learn all the tools you need to help your students make faster progress… all while having fun with creativity and saving time in lessons! Sign up for the Musico Quick Training Webinar today.”',
        link: '/book-a-meeting?utm_source=Website&utm_medium=Promo&utm_campaign=Certification'
    }
];

@inject('dialogStore')
@observer
class PromoDialog extends Component {


    meetingEventListenerSet = false;

    bookMeetingEventHandler = (event) => {
        if (event.origin !== window.location.origin) {
            return;
        }
        if (event.data && event.data.meetingBooked) {
            this.handleClose();
            window.removeEventListener('message', this.bookMeetingEventHandler);
        }
    };

    componentWillUnmount() {
        if (this.meetingEventListenerSet) {
            window.removeEventListener('message', this.bookMeetingEventHandler);
        }
    }


    onClick = () => {
        customEvent(events.CustomEvent, {category: category.Promo, action: actions.ClickBookNow, label: this.props.type});
        if (!this.meetingEventListenerSet) {
            this.meetingEventListenerSet = true;
            window.addEventListener('message', this.bookMeetingEventHandler);
        }
    };

    renderContent = () => {
        if (this.props.type === PromoType.None) {
            return null;
        }
        const promo = promoList.find(item => item.type === (this.props.type || PromoType.Teacher));
        const call = promo.type !== PromoType.Webinar;
        return (
            <div className="s-body">
                <div className="s-body-aside">
                    <img className="s-image" src={promo.image} alt="" />
                    {promo.person && <div className="s-person">
                        <div className="s-person-name">{promo.person.name}</div>
                        <div className="s-person-role">{promo.person.role}</div>
                    </div>}
                </div>
                <div className="s-body-main">
                    <div className="s-title">{promo.title}</div>
                    <div className="s-description">{promo.description}</div>
                    <a onClick={this.onClick}
                        className={`s-link ${call ? 'call' : ''}`}
                        target="blank" href={promo.link}>
                        <FormattedMessage id={`promoDialog.btnLabel.${call ? 'schedule' : 'bookNow'}`} />
                        {call && <SvgIcon className="s-link-icon"><Calendar/></SvgIcon>}
                    </a>
                </div>
            </div>
        );
    };

    handleClose = () => {
        setUserProperties({promo_11_19: true});
        this.props.dialogStore.closePromoDialog();
    }

    render() {
        const {closePromoDialog, showPromoDialog} = this.props.dialogStore;

        return (
            <DialogWrapper
                classes={{root: 'promo-dialog', paper: 'promo-dialog-paper'}}
                open={showPromoDialog} onClose={closePromoDialog}>
                <SvgIconButton containerClass="promo-close" onClick={this.handleClose}>
                    <Close />
                </SvgIconButton>
                <div className="promo-dialog-area">
                    {this.renderContent()}
                </div>
            </DialogWrapper>
        );
    }
}

export default PromoDialog;
